<template>
    <div class="mt-3" v-if="selectedMaterial._id">



        <b-container fluid>

            <b-row class="my-1">
                <b-col sm="2">
                    <label for="materialID">Material ID
                        <abbr title="Interne ID des Materials. Ist ein Prefix für das Angebot und auch der Ordner Name für die Bilder">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input disabled v-model="selectedMaterial.material" id="materialID" size="sm"
                                  type="text"></b-form-input>
                </b-col>

                <b-col sm="2">
                    <label for="materialNameID">Material Name
                        <abbr title="Der Name des Materials. Ist nur eine interne Bezeichnung und wird nicht auf Amazon verwendet">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.materialName" id="materialNameID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>



            <b-row class="my-1">
                <b-col sm="2">
                    <label for="productTypeID">Produkt-Typ
                        <abbr title="Die Bezeichnung des Produkt Typs von Amazon (z.B Unterscheidung bei Glas und Hüllen)">?</abbr>

                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input id="productTypeID" size="sm" type="text"
                                  v-model="selectedMaterial.feed_product_type"></b-form-input>
                </b-col>
                <b-col sm="2">
                    <label for="materialTypeID">Material Type
                        <abbr title="Das Material aus dem das Gehäuse des Produktes besteht. z.B. Kunstleder, Glas,...">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.materialType" id="materialTypeID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label for="styleNameID">Style Name
                        <abbr title="Name des Produkt Stils. Kann frei erfunden sein. Z.B. 'Silikon Hülle mit Motiv'">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.styleName" id="styleNameID" size="sm"
                                  type="text"></b-form-input>
                </b-col>

                <b-col sm="2">
                    <label for="formFactorID">Form Factor
                        <abbr title="Form der Hülle. z.B. Klapphülle, Panzerglas, Hülle, ...">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.formFactor" id="formFactorID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>



            <b-row class="my-1">
                <b-col sm="2">
                    <label for="included_componentsID">Komponenten
                        <abbr title="Welche zusätzlichen Komponenten enthält die Hülle? z.B. Reinigungstuch, Magnetverschluss, ...">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.included_components"
                                  id="included_componentsID" size="sm" type="text"></b-form-input>
                </b-col>
                <b-col sm="2">
                    <label for="parentSKUID">Parent SKU
                        <abbr title="Die SKU des Hauptangebots">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input disabled v-model="selectedMaterial.parentSKU" id="parentSKUID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label for="namePrefixID">Title Prefix
                        <abbr title="Der Name des Produkts, der später auf Amazon sichtbar ist">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.namePrefix" id="namePrefixID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
                <b-col sm="2">
                    <label for="browseNodeID">Browse Node
                        <abbr title="Die ID der Suchkategorie auf Amazon.">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.browse_node" id="browseNodeID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>


            <b-row class="my-1">
                <b-col sm="2">
                    <label for="genericKeywordsID">Generic Keywords
                        <abbr title="Die Schlüsselwörter, die nach dem Artikel suchen. Maximal 120 Zeichen.">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.generic_keywords" id="genericKeywordsID"
                                  size="sm" type="text"></b-form-input>
                </b-col>
                <b-col sm="2">
                    <label for="variationID">Variation
                        <abbr title="Unterscheidung der Variation. z.B: nur Größe, Farbe, oder Mix">?</abbr>
                    </label>
                </b-col>
                <b-col sm="4">
                    <b-form-input v-model="selectedMaterial.variation" id="variationID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>


            <b-row class="my-1">
                <b-col sm="2">

                    <label for="descriptionID">Beschreibung
                        <abbr title="Die Beschreibung des Artikels. Kann HTML enthalten.">?</abbr>

                    </label>
                </b-col>
                <b-col sm="10">
                    <b-form-input v-model="selectedMaterial.description" id="descriptionID" size="sm"
                                  type="text"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="my-1">

                <b-col sm="3">
                    <b-button v-b-modal.modal-specFeature id="specialFeaturesID">Specieal Features ansehen</b-button>
                    <!--                    <b-form-button v-b-modal.modal-models>Text</b-form-button>-->
                    <!--                    <b-form-input v-model="selectedMaterial.description" id="modal-models" size="sm" type="text"></b-form-input>-->
                </b-col>
                <b-col sm="3">
                    <b-button v-b-modal.modal-models id="modal-models">Kompatible Modelle ansehen
                    </b-button>
                    <!--                    <b-form-button v-b-modal.modal-models>Text</b-form-button>-->
                    <!--                    <b-form-input v-model="selectedMaterial.description" id="modal-models" size="sm" type="text"></b-form-input>-->
                </b-col>
                <b-col sm="3">
                    <b-button v-b-modal.modal-bullets id="bulletPoints">Bullet Points ansehen</b-button>
                </b-col>
                <b-col sm="3">
                    <b-dropdown :text="getUploadSizeName(this)"
                                class="m-md-2 hl-dropdown">
                        <b-dropdown-item-button @click="sizeSelectionChanged(item)" :key="item.name + index"
                                                v-for="(item, index) in uploadSizes">{{item.name}}
                        </b-dropdown-item-button>
                    </b-dropdown>
                </b-col>
            </b-row>



        </b-container>

        <b-modal hide-footer id="modal-specFeature" size="xl" title="Besondere Funktionen">

            <div v-for="(item, index) in selectedMaterial.specialFeatures" :key="item" class="input-group mt-1">
                <input type="text" class="form-control" v-model="selectedMaterial.specialFeatures[index]">
                <!--                                <h5 class="lead">{{item}}</h5>-->
                <button type="button" class="btn btn-danger" @click="selectedMaterial.specialFeatures.splice(index, 1)">Löschen</button>

            </div>
            <div class="input-group w-25 mt-3">
                <input type="text" class="form-control" v-model="specFeatureAdd">
                <div class="input-group-append">
                    <b-button class="btn btn-outline-light" type="button" @click="addSpecFeautre">hinzufügen</b-button>
                </div>
            </div>
        </b-modal>

        <b-modal hide-footer id="modal-models" size="xl" title="Kompatible Modelle">

            <div v-for="(item, index) in selectedMaterial.compatibleModels" :key="index" class="input-group mt-1">
                <input type="text" class="form-control" v-model="selectedMaterial.compatibleModels[index]" value="item.join(', ')">
                <button type="button" class="btn btn-danger" @click="deleteCompModel(index)">Löschen</button>
                <!--                                <button type="button" v-b-tooltip.hover title="Löschen" class="btn btn-danger" @click="selectedMaterial.compatibleModels.splice(index, 1)">&times;</button>-->

                <!--                                <div>{{item.join(', ')}}</div>-->
            </div>

            <div class="input-group w-25 mt-3">
                <input type="text" class="form-control" v-model="compatibleModelAdd">
                <div class="input-group-append">
                    <b-button class="btn btn-outline-light" type="button" @click="addCompatibleModels">hinzufügen</b-button>
                </div>
            </div>





        </b-modal>

        <b-modal hide-footer id="modal-bullets" size="xl" title="Bullet Points">

            <div v-for="(item, index) in selectedMaterial.bulletPoints" :key="index" class="input-group mt-1">
                <input type="text" class="form-control" v-model="selectedMaterial.bulletPoints[index]">

                <button type="button" class="btn btn-danger" @click="selectedMaterial.bulletPoints.splice(index, 1)">Löschen</button>
            </div>
            <div class="input-group w-25 mt-3">
                <input type="text" class="form-control" v-model="bulletPointAdd">

                <div class="input-group-append">
                    <b-button class="btn btn-outline-light" type="button" @click="addBulletPoint">hinzufügen</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "MaterialData",
        props:{
            uploadSizes: undefined,
            selectedMaterial: undefined
        },
        data() {
            return {
                selectedSize: {},
                isLoading: false,
                specFeatureAdd: '',
                bulletPointAdd: '',
                compatibleModelAdd: ''

            }
        },


        methods:{

            //

            getUploadSizeName(){
                return this.selectedMaterial.uploadSize ?  this.uploadSizes.filter(item => {
                    // debugger//eslint-disable-line no-debugger

                    return item._id === this.selectedMaterial.uploadSize
                })[0].name : 'Größe auswählen'
            },
            sizeSelectionChanged(selectedItem) {

                debugger//eslint-disable-line no-debugger

                this.selectedSize = selectedItem
                this.selectedMaterial.uploadSize = selectedItem._id
            },
            deleteCompModel(index){

                console.log("in deleteCompModel")
                console.log("Index %s", index)
                console.log(JSON.stringify(this.selectedMaterial.compatibleModels))
                this.selectedMaterial.compatibleModels.splice(index, 1);
                console.log(JSON.stringify(this.selectedMaterial.compatibleModels))
            },
            addSpecFeautre(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.specFeatureAdd.length != 0){
                    if(!this.selectedMaterial.specialFeatures) this.selectedMaterial.specialFeatures = []
                    this.selectedMaterial.specialFeatures.push(this.specFeatureAdd)
                    this.specFeatureAdd = ''
                }
            },

            addCompatibleModels(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.compatibleModelAdd.length != 0){
                    if(!this.selectedMaterial.compatibleModels) this.selectedMaterial.compatibleModels = []
                    let parsedModels = this.compatibleModelAdd.split(',').map(item => item.trim()).filter(item => item.length != 0)
                    this.selectedMaterial.compatibleModels.push(parsedModels)
                    this.compatibleModelAdd = ''
                }
            },

            addBulletPoint(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.bulletPointAdd.length != 0){
                    if(!this.selectedMaterial.bulletPoints) this.selectedMaterial.bulletPoints = []
                    this.selectedMaterial.bulletPoints.push(this.bulletPointAdd)
                    this.bulletPointAdd = ''
                }
            }
        }
    }
</script>

<style scoped>

</style>
